
import React from 'react';
import { Button } from "@/components/ui/button";
import { Download } from "lucide-react";
import { useIsMobile } from "@/hooks/use-mobile";
import { useAuth } from '@/hooks/useAuth';

interface DownloadButtonProps {
  onDownloadAll: () => void;
  disabled: boolean;
  selected: string[];
  totalVideos: number;
}

export const DownloadButton: React.FC<DownloadButtonProps> = ({
  onDownloadAll,
  disabled,
  selected,
  totalVideos
}) => {
  const isMobile = useIsMobile();
  const { isAuthenticated } = useAuth();
  
  const selectedCount = selected.length;
  const buttonText = selectedCount > 0 
    ? `Download ${selectedCount}${!isMobile ? ' selected videos' : ''}`
    : `Download All${!isMobile ? ` (${totalVideos})` : ''}`;

  const handleClick = (e: React.MouseEvent) => {
    e.preventDefault();
    console.log("Download button clicked", { isAuthenticated, selectedCount, totalVideos });
    onDownloadAll();
  };

  return (
    <Button 
      onClick={handleClick}
      disabled={disabled}
      className="bg-[#06DCE5] hover:bg-[#06DCE5]/90 text-[#000000] font-medium px-6 py-2 rounded-md"
      data-testid="download-button"
    >
      <Download className="mr-2 h-5 w-5" />
      {buttonText}
    </Button>
  );
};
